const isLogin = () => {
    if (localStorage.getItem('jwtToken')) {
        return true;
    }
    return false;
}

export default isLogin;